var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Vue, Watch } from 'vue-property-decorator';
import { Teacher as TeacherModel } from '@/models/Teacher';
import PageHeader from '@/components/page-header/PageHeader';
import { excludeRoles } from '@/support/ExcludeRoles';
import { RolesEnum } from '@/items/Roles';
let Teacher = class Teacher extends Vue {
    constructor() {
        super(...arguments);
        this.$pageTitle = 'Teacher';
        this.activeTab = '';
        this.teacher = new TeacherModel();
    }
    mounted() {
        this.initialize();
    }
    sync(teacher) {
        this.teacher = teacher;
    }
    initialize() {
        new TeacherModel()
            .include(['level', 'teacher', 'contract_hours'])
            .find(this.$route.params.id)
            .then((teacher) => {
            this.teacher = teacher;
            if (window.location.pathname.includes('levels')) {
                this.activeTab = `/teachers/${this.teacher.id}/levels`;
            }
            else if (window.location.pathname.includes('hours')) {
                this.activeTab = `/teachers/${this.teacher.id}/hours`;
            }
            else if (window.location.pathname.includes('calendar')) {
                this.activeTab = `/teachers/${this.teacher.id}/calendar`;
            }
            else {
                this.activeTab = `/teachers/${this.teacher.id}`;
            }
        });
    }
    get isAuthorized() {
        return this.$store.state.Auth.hasRole([
            RolesEnum.ADMIN,
            RolesEnum.ROOT,
            RolesEnum.TRAINER,
            RolesEnum.MANAGER,
            RolesEnum.TEACHER,
            RolesEnum.BOARD,
        ]);
    }
    get breadcrumbs() {
        return [
            { name: this.$tc('roles.user', 2) },
            { name: this.$tc('roles.teacher', 2), path: '/teachers' },
            { name: this.teacher.name || '', path: this.$route.path },
        ];
    }
    get user() {
        return this.$store.state.Auth;
    }
    get canViewHours() {
        if (this.user.id === this.teacher.id ||
            this.user.hasRole([RolesEnum.ADMIN, RolesEnum.TRAINER, RolesEnum.MANAGER, RolesEnum.ROOT])) {
            return true;
        }
        return false;
    }
    get exclude() {
        return excludeRoles[this.$store.state.version].scoolUsers.detail.navigationItems.includes(this.$store.state.Auth.roles[0].id);
    }
    routeChanged(teacherId) {
        if (teacherId) {
            this.initialize();
        }
    }
};
__decorate([
    Watch('$route.params.id'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], Teacher.prototype, "routeChanged", null);
Teacher = __decorate([
    Component({
        components: {
            PageHeader,
        },
    })
], Teacher);
export default Teacher;
